import store from '@/store' 
import { enrollPrimeCheck } from './constant' 

const isEnrollPrimeGroupUtil = {
  getGroupId() {
    return store.getters['groupId']
  },
  isEnrollPrimeGroup() {
    console.log('isEnrollPrimeGroupUtil.getGroupId() : ', this.getGroupId())
    console.log('isEnrollPrimeGroup : ', enrollPrimeCheck(this.getGroupId()))
    return enrollPrimeCheck(this.getGroupId())
  }
}

export default isEnrollPrimeGroupUtil